"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FRIENDLY_SEVERITY_NAMES = void 0;
exports.severityFromFriendlyName = severityFromFriendlyName;
exports.friendlyNameFromSeverity = friendlyNameFromSeverity;
const enums_1 = require("./enums");
exports.FRIENDLY_SEVERITY_NAMES = [
    'not-applicable',
    'pending',
    'pass',
    'recommendation',
    'indeterminate',
    'warning',
    'fail',
];
const SEVERITY_BY_FRIENDLY_NAME = {
    'not-applicable': enums_1.RequirementSeverity.NotApplicable,
    pending: enums_1.RequirementSeverity.Pending,
    pass: enums_1.RequirementSeverity.Pass,
    recommendation: enums_1.RequirementSeverity.Recommendation,
    indeterminate: enums_1.RequirementSeverity.Indeterminate,
    warning: enums_1.RequirementSeverity.Warning,
    fail: enums_1.RequirementSeverity.Fail,
};
const FRIENDLY_NAME_BY_SEVERITY = new Map(exports.FRIENDLY_SEVERITY_NAMES.map((name) => [SEVERITY_BY_FRIENDLY_NAME[name], name]));
function severityFromFriendlyName(name) {
    return SEVERITY_BY_FRIENDLY_NAME[name];
}
function friendlyNameFromSeverity(severity) {
    const name = FRIENDLY_NAME_BY_SEVERITY.get(severity);
    if (name === undefined) {
        throw new Error(`No friendly severity name for numeric severity ${severity}`);
    }
    return name;
}
//# sourceMappingURL=severity-names.js.map